var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 13,
    viewBox: "0 0 24 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.658915 0.329504C1.09825 -0.109835 1.81057 -0.109835 2.24991 0.329504L11.5105 9.41727C11.8034 9.71016 12.2783 9.71016 12.5712 9.41727L21.7499 0.329505C22.1893 -0.109834 22.9016 -0.109835 23.3409 0.329505C23.7802 0.768844 23.7802 1.48116 23.3409 1.92049L12.8363 12.3341C12.397 12.7734 11.6847 12.7734 11.2454 12.3341L0.658915 1.92049C0.219574 1.48115 0.219576 0.768844 0.658915 0.329504Z",
    fill: "#C2C2C2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrowDown.32b0052836e0fe1e0ee58884121f39bb.svg";
export { ForwardRef as ReactComponent };